import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { submitRequest } from './submitRequest';
import { ScheduleJob } from '@mercedes-benz/pmas-common';

export class CalendarApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(discoveryApi: DiscoveryApi, fetchApi: FetchApi) {
    this.discoveryApi = discoveryApi;
    this.fetchApi = fetchApi;
  }

  async getCalendar(): Promise<ScheduleJob[]> {
    return submitRequest({
      discoveryApi: this.discoveryApi,
      fetchApi: this.fetchApi,
      method: 'GET',
      path: `/calendar`,
    });
  }
}
